import { format, subDays } from 'date-fns';

export const nfFilters = {
  DATE: 'date-filter',
  SHIPPING_COMPANY: 'shipping-company-filter',
  REGIONS: 'regions-filter',
  NF_TYPE: 'nf-type',
  ALLOWANCE: 'allowance',
  CONTRACTEDSERVICE: 'contracted-service',
  SCHEDULING: 'scheduling',
  STATUS: 'status-filter',
  PERFORMANCE: 'performance',
  CUSTOMERS: 'customers',
  FOLLOWING: 'follow-up',
  SUBSIDIARIES: 'subsidiaries',
  SUBSIDIARIES_LUFT: 'subsidiaries-luft',
  SHIPPING_COMPANIES: 'shipping-companies',
};

export const DATE_FILTERS = {
  BY_SOLICITATION: 'Data de solicitação',
  BY_CONTRACTED_TERM: 'Data do prazo contratado',
};

export const dateFilterToDays = {
  BY_CONTRACTED_TERM: 1,
  BY_SOLICITATION: 2,
};

export const PERIOD_FILTERS = {
  LAST_30_DAYS: 'Últimos 30 dias',
  LAST_60_DAYS: 'Últimos 60 dias',
  LAST_90_DAYS: 'Últimos 90 dias',
  CUSTOM: 'Personalizado...',
};

export const periodFilterToDays = {
  LAST_30_DAYS: 30,
  LAST_60_DAYS: 60,
  LAST_90_DAYS: 90,
};

export const periodFormatted = {
  LAST_30_DAYS: format(
    subDays(new Date(), periodFilterToDays.LAST_30_DAYS),
    'yyyy-MM-dd',
  ),
  LAST_60_DAYS: format(
    subDays(new Date(), periodFilterToDays.LAST_60_DAYS),
    'yyyy-MM-dd',
  ),
  LAST_90_DAYS: format(
    subDays(new Date(), periodFilterToDays.LAST_90_DAYS),
    'yyyy-MM-dd',
  ),
  CUSTOM: format(new Date(), 'yyyy-MM-dd'),
};

export const REGION = {
  NORTH: 1,
  MORTHEAST: 2,
  MIDWEST: 3,
  SOUTHEAST: 4,
  SOUTH: 5,
};

export const regionEnumTransKey = {
  [REGION.NORTH]: 'Norte',
  [REGION.MORTHEAST]: 'Nordeste',
  [REGION.MIDWEST]: 'Centro-oeste',
  [REGION.SOUTHEAST]: 'Sudeste',
  [REGION.SOUTH]: 'Sul',
};

export const INVOICE = {
  MY_INVOICE: 2,
  CLIENT_INVOICE: 1,
};

export const invoiceEnumTransKey = {
  [INVOICE.MY_INVOICE]: 'Minhas notas',
  [INVOICE.CLIENT_INVOICE]: 'Notas de clientes',
};

export const ALLOWANCE = {
  WITHOUT_ALLOWANCE: 1,
  WITH_ALLOWANCE_ACCEPTED: 2,
  WITH_ALLOWANCE_NOT_ACCEPTED: 3,
};

export const allowanceEnumTransKey = {
  [ALLOWANCE.WITHOUT_ALLOWANCE]: 'Sem abono',
  [ALLOWANCE.WITH_ALLOWANCE_ACCEPTED]: 'Abono acatado',
  [ALLOWANCE.WITH_ALLOWANCE_NOT_ACCEPTED]: 'Abono não acatado',
};

export const SCHEDULING = {
  TO_SCHEDULING: 1,
  NOT_SCHEDULING: 2,
};

export const schedulingEnumTransKey = {
  [SCHEDULING.TO_SCHEDULING]: 'Entrega agendada',
  [SCHEDULING.NOT_SCHEDULING]: 'Entrega não agendada',
};

export const CONTRACTED_SERVICE = {
  WMS_TMS: 1,
  WMS: 2,
  TMS: 3,
};

export const contratedServiceEnumTransKey = {
  [CONTRACTED_SERVICE.WMS_TMS]: 'Armazém e Transporte',
  [CONTRACTED_SERVICE.WMS]: 'Somente Armazém',
  [CONTRACTED_SERVICE.TMS]: 'Somente Transporte',
};

export const PERFORMANCE = {
  ON_TIME: 1,
  RISK_DELAY: 2,
  DELAYED: 3,
};

export const performanceEnumTransKey = {
  [PERFORMANCE.ON_TIME]: 'No prazo',
  [PERFORMANCE.RISK_DELAY]: 'Risco de atraso',
  [PERFORMANCE.DELAYED]: 'Atrasado',
};

export const STATUS = {
  SEPARATION: 1,
  INTERCHANGE: 4,
  SHIPMENT: 5,
  TRANSFER: 6,
  CARRIER_IN_ROUTE: 7,
  DELIVERED: 8,
  REFUSED_DELIVERED: 12,
  CANCELED: 9,
};

export const statusEnumTransKey = {
  [STATUS.SEPARATION]: 'Separação',
  [STATUS.INTERCHANGE]: 'Entrega ao transporte',
  [STATUS.SHIPMENT]: 'Embarque',
  [STATUS.TRANSFER]: 'Transferência',
  [STATUS.CARRIER_IN_ROUTE]: 'Rota de entrega',
  [STATUS.DELIVERED]: 'Finalizado e entregue',
  [STATUS.REFUSED_DELIVERED]: 'Finalizado e recusado',
  [STATUS.CANCELED]: 'Cancelado',
};

export const FOLLOWING = {
  FOLLOWING: 2,
  NOT_FOLLOWING: 1,
};

export const followingEnumTransKey = {
  [FOLLOWING.FOLLOWING]: 'Notificações: ligado',
  [FOLLOWING.NOT_FOLLOWING]: 'Notificações: desligado',
};
